<div role="document">
  <div class="modal-header"></div>
  <div class="modal-body">
    <h2
      class="modal-title confirmation-title-font"
      id="setAcceptCenterLongTitle"
    >
      {{ this.title }}
    </h2>
    <p class="confirmation-body-font">{{ this.textToDisplay }}</p>
  </div>
  <div class="modal-footer">
    <div class="row col-6 justify-content-end buttons">
      <div class="col-6 ">
        <button
          type="button"
          id="confirm"
          class="btn btn-lg btn-outline-dark close-modal-bottom action-button"
          data-dismiss="modal"
          (click)="confirmed()"
        >
          {{ confirmButtonText }}
        </button>
      </div>
      <div class="col-6">
        <button
          type="button"
          id="decline"
          class="btn btn-lg btn-outline-dark close-modal-bottom action-button"
          (click)="declined()"
        >
          {{ declineButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
